<template>
  <v-dialog v-bind:width="width">
    <template v-slot:activator="{on}">
      <v-btn tile color="success" v-on="on"><v-icon>mdi-plus</v-icon><slot name="text" /></v-btn>
    </template>
    <v-card>
      <slot />
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'v-dialog-btn',
  props: {
    width: {type: Number, default: 600}
  }
}
</script>